import { Component} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';
import { TopicService } from '../topic.service';
import { BinaryComponent } from '../binary/binary.component';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-binary-search',
  templateUrl: './binary-search.component.html',
  styleUrls: ['../binary/binary.component.css','./binary-search.component.css']
})
export class BinarySearchComponent extends BinaryComponent {

  constructor(protected activatedRoute: ActivatedRoute, protected messageService: MessageService, protected topicService: TopicService, protected http: HttpClient) {
    super(activatedRoute, messageService, topicService, http);
   }

}
